import { render, staticRenderFns } from "./SapImport.vue?vue&type=template&id=2536dc2a"
import script from "./SapImport.vue?vue&type=script&lang=js"
export * from "./SapImport.vue?vue&type=script&lang=js"
import style0 from "./SapImport.vue?vue&type=style&index=0&id=2536dc2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports